import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyACyDyBls0WXOEXMl0FHB8Nsd-nLk9KfxY",
  authDomain: "dr-meditation-app.firebaseapp.com",
  projectId: "dr-meditation-app",
  storageBucket: "dr-meditation-app.appspot.com",
  messagingSenderId: "1040801765957",
  appId: "1:1040801765957:web:e0d5359be5218d5b4ca12c",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
